import React from 'react';

const Event = () => {
  return (
    <div className="event-description">
      <div className="event-title">
        <h1>Tutti gli eventi del</h1><span>16 Agosto</span>
      </div>
      <div className="event-text">
        <img src={`${process.env.PUBLIC_URL}/images/eventi16agosto.jpg`} alt="eventi del 16 Agosto" className="event-map"/>
        
        <p className="event-detail">
          <ul>
            <li><strong>Marco Bracci Guitar</strong> da Tirrenia doc Caffè</li>
            <li><strong>Erriquenz Trio</strong> vi accompagnerà con la sua musica</li>
            <li><strong>The memories '90</strong> aperitivo, cena, musica da La Vela Tirrenia</li>
            <li><strong>Solidago Fitmusic</strong> vi mostreranno le loro abilità sportive</li>
            <li><strong>OrangeTeam LUG</strong> vi aspetta in piazza con le mitiche costruzioni in Mattoncini Lego®️</li>
            <li><strong>I Chicchi d'Uva</strong> vi meraviglieranno con i loro giochi in piazza</li>
            <li><strong>Clown Prezzemolina Animazioni</strong> da Osteria di Tirrenia</li>
            <li>Lo stand <strong>delle decorazioni all'uncinetto</strong> vi aspetta per ammirare e acquistare le loro creazioni</li>
          </ul>
        </p>
        <h3>Non perdere nemmeno un evento! <a href="https://www.litoralepisano.app" target="_blank">Scarica l'App del Litorale Pisano</a> per il calendario completo.</h3>
        {/*<p>Un'iniziativa di Vivi Tirrenia aps, in collaborazione con Marenia e il Comune di Pisa, per rendere indimenticabile la vostra estate sul litorale.<br />
        Venite a scoprire il cuore pulsante di Tirrenia - vi aspettiamo per celebrare insieme le notti d'estate!</p>*/}
      </div>
    </div>
  );
}

export default Event;